<div class="container">
  <div class="door-list mt-3 mb-3" *ngIf="relayScriptRules && relayScriptRules.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Office</th>
        <th scope="col">Relay Board</th>
        <th scope="col">Time Period</th>
        <th scope="col">Active</th>
        <th scope="col">Modifier</th>
        <th scope="col">Relays</th>
<!--        <th scope="col">Delay before, min</th>-->
<!--        <th scope="col">Delay after, min</th>-->
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let relayScriptRule of relayScriptRules">
        <td>{{ relayScriptRule.id }}</td>
        <td>{{ getOfficeName(relayScriptRule.officeId) }}</td>
        <td><ng-container *ngIf="relayBoards">{{ getRelayBoardName(relayScriptRule.relayBoardId) }}</ng-container></td>
        <td><ng-container *ngIf="timePeriods">{{ getTimePeriodName(relayScriptRule.timePeriodId) }}</ng-container></td>
        <td>{{ relayScriptRule.isActive }}</td>
        <td>{{ relayScriptRule.modifier }}</td>
        <td>
          <ng-container *ngFor="let r of relayScriptRule.relayList; let i = index">
            {{ getRelayName(r.relayId) + ' ' }}
          </ng-container>
        </td>
<!--        <td>{{ relayScriptRule.startDelay }}</td>-->
<!--        <td>{{ relayScriptRule.endDelay }}</td>-->
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(relayScriptRule)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(relayScriptRule)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
